var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "128px",
    height: "128px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#fbaf3c",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(2,2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,2c-34.2,0 -62,27.8 -62,62c0,10.5 2.59922,20.80039 7.69922,29.90039l-5.29883,19.40039c-0.9,3.1 -0.00117,6.29961 2.29883,8.59961c2.3,2.3 5.50156,3.20039 8.60156,2.40039l20.19922,-5.30078c8.8,4.6 18.59961,7 28.59961,7c34.2,0 62,-27.8 62,-62c0,-16.6 -6.39961,-32.10078 -18.09961,-43.80078c-11.8,-11.7 -27.4,-18.19922 -44,-18.19922zM64,8c15,0 29.09961,5.80039 39.59961,16.40039c10.6,10.6 16.50039,24.69961 16.40039,39.59961c0,30.9 -25.1,56 -56,56c-9.3,0 -18.60078,-2.40078 -26.80078,-6.80078c-0.4,-0.2 -0.89844,-0.39844 -1.39844,-0.39844c-0.3,0 -0.50078,-0.00039 -0.80078,0.09961l-21.30078,5.59961c-1.5,0.4 -2.49844,-0.40078 -2.89844,-0.80078c-0.4,-0.4 -1.20078,-1.39844 -0.80078,-2.89844l5.59961,-20.60156c0.2,-0.8 0.10117,-1.59883 -0.29883,-2.29883c-4.8,-8.4 -7.30078,-18.10039 -7.30078,-27.90039c0,-30.9 25.1,-56 56,-56zM64,17c-25.9,0 -47,21 -47,47c0,8.3 2.20078,16.4 6.30078,23.5c1.6,2.8 1.99922,6.09922 1.19922,9.19922l-2.90039,10.5l11.20117,-2.89844c1,-0.3 2,-0.40039 3,-0.40039c2,0 3.99922,0.5 5.69922,1.5c6.9,3.6 14.6,5.59961 22.5,5.59961c25.9,0 47,-21.1 47,-47c0,-12.6 -4.90078,-24.40078 -13.80078,-33.30078c-8.8,-8.8 -20.59922,-13.69922 -33.19922,-13.69922zM43.09961,36.69922h2.80078c1.1,0 2.19883,0.1 3.29883,2.5c1.3,2.9 4.2,10.20039 4.5,10.90039c0.4,0.7 0.60156,1.59961 0.10156,2.59961c-0.5,1 -0.7,1.6 -1.5,2.5c-0.7,0.9 -1.60117,1.90156 -2.20117,2.60156c-0.7,0.7 -1.49961,1.5 -0.59961,3c0.9,1.5 3.79922,6.29922 8.19922,10.19922c5.6,5 10.40039,6.60078 11.90039,7.30078c1.5,0.7 2.30117,0.59961 3.20117,-0.40039c0.9,-1 3.69922,-4.30078 4.69922,-5.80078c1,-1.5 2.00078,-1.19922 3.30078,-0.69922c1.4,0.5 8.59961,4.09883 10.09961,4.79883c1.5,0.7 2.49883,1.10117 2.79883,1.70117c0.4,0.8 0.40117,3.69922 -0.79883,7.19922c-1.2,3.4 -7.2,6.8 -10,7c-2.7,0.2 -5.20117,1.20078 -17.70117,-3.69922c-15,-5.9 -24.49922,-21.30078 -25.19922,-22.30078c-0.7,-1 -6,-7.99883 -6,-15.29883c0,-7.3 3.79922,-10.80078 5.19922,-12.30078c1.4,-1.5 2.90039,-1.80078 3.90039,-1.80078z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp2);
export default __webpack_public_path__ + "static/media/whatsapp-2.a099773c20ec99659e99f74e5cbc6fae.svg";
export { ForwardRef as ReactComponent };